import axios from 'axios';

import ArcadaApiService from 'helpers/service/arcadaApiService';
import { HOST_API } from 'config';
import { PATH_PAGE, PATH_AUTH } from 'routes/paths';
import { setSession } from './jwt';

const axiosInstance = axios.create({
  baseURL: HOST_API,
});

// Multi-tenant: identify which Company (tenant) this client belongs to via the
// publishable app key. The backend uses it to resolve the tenant for anonymous
// / public requests — branding before login, and login when the same email
// exists in more than one company (see backend apps/core/tenant.py).
// For local testing you can switch tenants at runtime from the browser console
// with `localStorage.setItem('companyKey', '<api_key>')` (then reload); it falls
// back to the build-time REACT_APP_COMPANY_KEY.
const getCompanyKey = () =>
  localStorage.getItem('companyKey') || process.env.REACT_APP_COMPANY_KEY || '';

axiosInstance.interceptors.request.use((config) => {
  const companyKey = getCompanyKey();
  if (companyKey) {
    config.headers['X-Company-Key'] = companyKey;
  }
  return config;
});

const defautlErrorMessage = { message: ['Ինչ որ բան սխալ է'] };

axiosInstance.interceptors.response.use(
  (response) => response,
  (error) => {
    const { status } = error?.response || {};

    if (status >= 500 || error.code === 'ECONNABORTED') {
      window.location.href = PATH_PAGE.page500;
      return Promise.reject();
    }

    // if (status === 404) {
    //   window.location.href = PATH_PAGE.page404;
    //   return Promise.reject();
    // }

    if ([401, 403].includes(status)) {
      ArcadaApiService.auth.logout();
      setSession(null);
      localStorage.removeItem('user');
      localStorage.removeItem('accessToken');
      window.location.href = PATH_AUTH.login;
      return Promise.reject();
    }

    return Promise.reject((error.response && error.response.data) || defautlErrorMessage);
  }
);

export default axiosInstance;
